export default __webpack_public_path__ + "static/media/calconvert_l3.1866062d.png";